<div [class.modal]="true" [class.fade]="true" [class.in]="true" role="dialog" style="display: none;" id="show-group-dialog" appDraggable dragTarget="#show-group-dialog">
	<div class="modal-dialog modal-sm">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
				<h4 class="modal-title">Group <span id="showGroupTitleName">{{mGroupName}}</span></h4>
			</div>
			<div class="modal-body">
				<div *ngIf="mItemNames != null" id="showGroupItems">
					<ng-container *ngFor="let itemName of mItemNames">
						<div>{{itemName}}</div>
					</ng-container>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" data-dismiss="modal"><i class="fa fa-check" aria-hidden="true"></i> OK</button>
			</div>
		</div>
	</div>
</div>